import React, { useCallback } from 'react';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import ThreeppModal from 'components/common/Modal/Modal';

import './InputFieldsValidationModal.scss';

export const InputFieldsValidationModal = props => {
  const { toggle, isOpen, isNewRecord } = props;
  const { t } = useTranslation();

  const close = useCallback(() => toggle(), [toggle]);

  return (
    <ThreeppModal isOpen={isOpen} toggle={toggle} classes="validation-error-modal" header={t('assessment.validations.validationError')} size="sm">
      <div className="validation-error-message">
        {t(isNewRecord ? 'newRecord.validations.validationErrorMsg' : 'assessment.validations.validationErrorMsg')}
      </div>
      <div className="action-row">
        <Button testId="inputValidationModal-okay" className="btn-ok" buttonstyle="primary" onClick={close}>
          {t('assessment.validations.okay')}
        </Button>
      </div>
    </ThreeppModal>
  );
};
